import React from "react";
import { useMediaQuery } from 'react-responsive';
import BecomeApiProviderTemplate from "./BecomApiProviderTemplate";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const WorkingWithCdcApis = () => {
    const smallScreens = useMediaQuery({ maxWidth: 639});

    return (
        <BecomeApiProviderTemplate>
            <section>
                <h1 className="a-one-paturegular fs-40">Working with CDC APIs</h1>
                <p>Integrating with CDC APIs can help your app's users get faster, more reliable access to CDC data. Discover what it's like to work with CDC APIs, including information about rate limiting, feature requests, status updates, and more.</p>
            </section>
            <section className="grid-col-12">
                <div className="grid-row grid-gap flex-justify-center">
                <div className="display-none tablet:display-block grid-col-4"></div>
                <div className={ smallScreens ? "grid-col-8 w-100" : "grid-col-8"}>
                    <Accordion className="mb-5" slotProps={{ heading: { component: 'h2' } }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                        className="accordion-summary"
                    >
                        <Typography component="span" className="patua-one-regular fs-17">Modifications & Updates</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <p>
                            We are constantly onboarding new APIs and updating current APIs to adhere to best practices. Please refer to the release pages of each API to stay up-to-date with any modifications that may have taken place. Our team is available <a href='/support-ticket/submit-support-ticket' target="_blank" rel="noopener noreferrer">here</a> in case you need further support.
                        </p>
                    </AccordionDetails>
                    </Accordion>
                    <Accordion className="mb-5">
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2-content"
                        id="panel2-header"
                        className="accordion-summary"
                    >
                        <Typography component="span" className="patua-one-regular fs-17">Deprecation & Deactivation</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <p>
                            We occasionally deactivate features and versions of APIs based on updates and new technology. Before any functionality is deactivated, we will announce the change through release notes and note the deprecated functionality. We intend to make as few breaking changes as possible and to let you know as far in advance as possible.
                        </p>
                    </AccordionDetails>
                    </Accordion>
                    <Accordion className="mb-5">
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel3-content"
                        id="panel3-header"
                        className="accordion-summary"
                    >
                        <Typography component="span" className="patua-one-regular fs-17">Rate Limiting</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <p>
                            Rate limiting is enforced at 300 requests per minute per IP address.
                        </p>
                    </AccordionDetails>
                    </Accordion>
                    <Accordion className="mb-5">
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel4-content"
                            id="panel4-header"
                            className="accordion-summary"
                        >
                            <Typography component="span" className="patua-one-regular fs-17">Environments</Typography>
                        </AccordionSummary>
                    <AccordionDetails>
                        <p>
                            We closely monitor the production environment to ensure CDC data remains safe and secure. Before releasing anything to production, the APIs are thoroughly tested by our team through several environments to ensure a seamless transition on and off of Digital Gateway.
                        </p> 
                    </AccordionDetails>
                    </Accordion>
                    <Accordion className="mb-5">
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel5-content"
                        id="panel5-header"
                        className="accordion-summary"
                    >
                        <Typography component="span" className="patua-one-regular fs-17">Support</Typography>
                    </AccordionSummary>
                        <AccordionDetails>
                            <p>
                                If you find an issue that may impact an API’s status, let us know through our <a href='/support-ticket/submit-support-ticket' target="_blank" rel="noopener noreferrer">support</a> page and we will get back to you within one business day. We appriecate your efforts with keeping our APIs working and functional.                    
                            </p>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className="mb-5">
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel6-content"
                        id="panel6-header"
                        className="accordion-summary"
                    >
                        <Typography component="span" className="patua-one-regular fs-17">Managing feature requests</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <p>
                            We look to our consumers for feature requests, such as suggestions for improvements to functionality or ideas for new features. Improving your experience is our primary concern.
                        </p>
                        <p>
                           If you have a feature request for us, let us know through our <a href='/support-ticket/submit-support-ticket' target="_blank" rel="noopener noreferrer">support</a> page. We’ll let you know the status of your request at least once a month until it is complete. 
                        </p>
                    </AccordionDetails>
                    </Accordion>
                </div>
                </div>
            </section>
        </BecomeApiProviderTemplate>
    )
}

export default WorkingWithCdcApis;